import React from "react";
import LegalPage, { DocSections } from "@/pages/legal/LegalPage";
import { REFUND } from "@/pages/legal/_content";

const RefundPolicy = () => <LegalPage doc={REFUND}><DocSections sections={REFUND.sections}/></LegalPage>;
export default RefundPolicy;
